import ClientWebservice from './ClientWebService';
import { blumarWebserviceAxios } from './HttpHelper';

let axios = blumarWebserviceAxios();


export default class ServicePricesWebservice extends ClientWebservice {
	constructor(client) {
		super('/services');
		this.client = client;
		this.auth = {
			username: this.client.login,
			password: this.client.key
		};
	};

	filter(criteria = {}) {
			return axios.get( this.url+'/prices', {
				params: criteria,
				headers:{
					'Accept': '*/*',
					'Access-Control-Allow-Origin' : '*',
				},
				auth:this.auth
		});
	};

	listTransferPrices(criteria = {}) {
		return axios.get( this.url+'/transfer/prices', {
			params: criteria,
			headers:{
				'Accept': '*/*',
				'Access-Control-Allow-Origin' : '*',
			},
			auth:this.auth
		});
	};

	listToursPrices(criteria = {}) {
		return axios.get(`${this.url}/tours/prices`,{
			params: criteria,
			headers:{
				'Accept': '*/*',
				'Access-Control-Allow-Origin' : '*',
			},
			auth:this.auth
		});
	};
}



// WEBPACK FOOTER //
// ./src/services/ServicePricesWebservice.js